import api from "./api";

const journalVoucher6Service = {
  create: (data) => api.post("/private/journal-voucher-6", data),
  update: (id, data) => api.put(`/private/journal-voucher-6/${id}`, data),
  delete: (id) => api.delete(`/private/journal-voucher-6/${id}`),
  findAll: (params) => api.get("/private/journal-voucher-6", { params }),
  findById: (id) => api.get(`/private/journal-voucher-6/${id}`),
  preview: (params) => api.get("/private/journal-voucher-6/sync/preview", { params }),
  sync: (params) => api.post("/private/journal-voucher-6/sync", null, { params }),
};

export default journalVoucher6Service;
